// extracted by mini-css-extract-plugin
module.exports = {"detail":"video_detail_detail__1YiUK","description":"video_detail_description__24ElA"};